import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

const Home = Loadable(lazy(() => import('views/home')));
const Powerball = Loadable(lazy(() => import('views/game/powerball')));
const Bitball = Loadable(lazy(() => import('views/game/bitball')));
const Lottery = Loadable(lazy(() => import('views/game/lottery')));
const Wallet = Loadable(lazy(() => import('views/wallet')));
const Mypage = Loadable(lazy(() => import('views/mypage')));
const Logout = Loadable(lazy(() => import('views/logout')));
const GameInfo = Loadable(lazy(() => import('views/gameinfo')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <Home />
        },
        {
            path: '/game/powerball',
            element: <Powerball />
        },
        {
            path: '/game/bitball',
            element: <Bitball />
        },
        {
            path: '/game/lottery',
            element: <Lottery />
        },
        {
            path: '/game/lottery',
            element: <Lottery />
        },
        {
            path: '/wallet',
            element: <Wallet />
        },
        {
            path: '/mypage',
            element: <Mypage />
        },
        {
            path: '/logout',
            element: <Logout />
        },
        {
            path: '/gameinfo/:game',
            element: <GameInfo />
        },

        
    ]
};

export default MainRoutes;
